
export default {
  button: {
    closeWindow:"ปิดหน้าต่าง",
    sortBy:"เรียงตาม",
    allRead:"อ่านแล้วทั้งหมด",
    cropImg:"ตัดภาพ",
    login: "เข้าสู่ระบบ",
    register: "ลงทะเบียน",
    addToCart: "เพิ่มลงตะกร้า",
    purchase: "ชำระเงิน",
    viewPrivileges: "ดูสิทธิพิเศษ",
    close: "ปิด",
    seeAll: "ดูทั้งหมด",
    selectPackage: "เลือกแพ็กเกจ",
    checkIn: "บันทึกเวลาเข้าสอน",
    clickToClockIn: "กดเพื่อลงชื่อเข้าสอน",
    alreadyClockIn: "ลงชื่อเข้าสอนแล้ว",
    save: "บันทึก",
    cancel: "ยกเลิก",
    confirm: "ยืนยัน",
    search: "ค้นหา",
    or: "หรือ",
    upload: "อัปโหลด",
    preview: "ดูตัวอย่าง",
    accept: "ยอมรับ",
    decline: "ปฏิเสธ",
    viewMore:"ดูเพิ่มเติม",
  },
  message: {
    recommandCategory:"อาณาจักรสำหรับคุณ",
    hotCategory:"อาณาจักรยอดนิยม",
    username: "ชื่อผู้ใช้/OneID",
    password: "รหัสผ่าน",
    confirmPassword: "ยืนยันรหัสผ่าน",
    termofService: "เงื่อนไขการบริการ & นโยบายความเป็นส่วนตัว",
    usernameHint: "กรุณากรอกชื่อผู้ใช้/oneID",
    passwordHint: "กรุณากรอกรหัสผ่าน",
    seeAll: "ดูทั้งหมด",
    course: "คอร์ส",
    time: "เวลา",
    searchResult: "ผลลัพธ์การค้นหา",
    courseType: "ประเภทคอร์ส",
    regCourse: "คอร์สทั่วไป",
    shortCourse: "คอร์สระยะสั้น",
    purchaseHistory: "ประวัติการลงทะเบียนคอร์ส",
    notification: "การแจ้งเตือน",
    cart: "ตะกร้าสินค้า",
    cancel: "ยกเลิก",
    next: "ถัดไป",
    back: "ย้อนกลับ",
    all: "ทั้งหมด",
    close: "ปิด",
    price: "ราคา",
    purchase: "ชำระเงิน",
    totalPrice: "ราคาชำระทั้งหมด",
    pendingPayment: "รอชำระเงิน",
    completedPayment: "ชำระเงินแล้ว",
    cancelledPayment: "ยกเลิกคำสั่งซื้อนี้แล้ว",
    orderID: "หมายเลขคำสั่งซื้อ",
    changeProfile: "เปลี่ยนรูปโปรไฟล์",
    delete: "ลบ",
    edit: "แก้ไข",
    selectAll: "เลือกทั้งหมด",
    profile: "ข้อมูลส่วนตัว",
    coursePeriod: "ความยาวคอร์ส/ครั้ง",
    dateAndTime: "วันและเวลา",
    registrationDate: "วันที่รับสมัคร",
    classDate: "วันที่เรียน",
    classTime: "เวลาเรียน",
    coach: "ผู้สอน",
    selectCoach: "เลือกคุณครูผู้สอน",
    courseDetail: "รายละเอียดคอร์ส",
    packageDetail: "รายละเอียดแพ็กเกจ",
    viewPrivileges: "ดูสิทธิพิเศษ",
    benefits: "สิทธิประโยชน์",
    seeMore: "ดูรายละเอียดเพิ่มเติม",
    buyThisCourse: "ซื้อคอร์ส/เพิ่มลงตะกร้า",
    reserveThisCourse: "จองคอร์ส",
    addToCart: "เพิ่มลงในตะกร้า",
    seats: "ที่นั่ง",
    hoursPerTime: "จำนวนชั่วโมง/ครั้ง",
    selectPackage: "เลือกแพ็กเกจนี้!",
    selectedPackage: "เลือกแพ็กเกจนี้แล้ว",
    selectPackageStep: "เลือกแพ็กเกจ",
    selectDateStep: "เลือกเวลาเรียนและโค้ช",
    selectStudentStep: "กรอกข้อมูลผู้เรียน",
    seftRegister: "ลงทะเบียนให้ตนเอง",
    otherResgister: "ลงทะเบียนให้ผู้อื่น",
    fillParentInfo: "กรอกข้อมูลผู้ปกครอง",
    ParentPhone: "เบอร์โทรศัพท์ผู้ปกครอง",
    studntCount: "ผู้เรียนคนที่",
    level: "ระดับชั้น",
    notSpecified: "ไม่ระบุ",
  },
  language: {
    th: "ไทย",
    en: "อังกฤษ",
  },
  rules: {
    otherDiscount:"ส่วนลดเพิ่มเติมต้องไม่เกิน {amount} บาท",
    required: "จำเป็นต้องกรอกข้อมูล",
    email: "รูปแบบอีเมลไม่ถูกต้อง",
    minLength: "ต้องมีความยาวอย่างน้อย",
    minPassword: "มีความยาวอย่างน้อย 8 ตัวอักษร",
    englishRule: "ตัวอักษรภาษาอังกฤษ",
    numberRule: "ตัวเลขอารบิก",
    maxLength: "ต้องมีความยาวไม่เกิน",
    char: "ตัวอักษร",
    minStudent: "รองรับผู้เรียนได้อย่างน้อย 1 คน",
    minNumer: "ต้องเป็นตัวเลขที่มากกว่าหรือเท่ากับ {n}",
    number: "กรุณากรอกตัวเลขเท่านั้น",
    password:
      "รหัสผ่านต้องมีตัวอักษรภาษาอังกฤษ ตัวเลขอย่างน้อย 1 ตัว และมีความยาวขั้นต่ำ 8 ตัวอักษร",
    emailPassNotMatch:
      "ชื่อผู้ใช้หรือรหัสผ่านของคุณไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง",
    matchPassword: "รหัสผ่านไม่ตรงกัน กรุณาตรวจสอบอีกครั้ง",
    thai: "กรุณากรอกข้อมูลเป็นภาษาไทย",
    eng: "กรุณากรอกข้อมูลเป็นภาษาอังกฤษ",
    text: "กรุณากรอกข้อมูลเป็นอักขระเท่านั้น",
    phone: "รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง กรุณาลองอีกครั้ง",
    format: "กรุณากรอกข้อมูลตามรูปแบบที่กำหนด",
    discount: "กรุณาระบุส่วนลดที่ต่ำกว่าราคาคอร์สเรียน",
    period: "กรุณาตรวจสอบวันที่เริ่มต้นและวันที่สิ้นสุดอีกครั้ง",
  },
  errorMessage: {
    invalidReserveDate: "ไม่สามารถจองคอร์สนี้ได้ในขณะนี้ เนื่องจากไม่อยู่ในช่วงเวลาจอง",
    noExportData:"ไม่พบข้อมูลที่คุณต้องการจะนำออก",
    // EnrollError
    enrollSchedule:"ไม่สามารถซื้อคอร์สได้ เนื่องจากช่วงเวลาที่เปิดสอนไม่สอดคล้องกับวันที่เรียน",
    enrollRole: "ไม่สามารถลงทะเบียนเรียนคอร์สนี้ได้ เนื่องจากบทบาทของผู้ใช้ไม่ถูกต้อง",
    enrollCoach: "ไม่สามารถลงทะเบียนเรียนคอร์สนี้ได้ เนื่องจากไม่พบโค้ชที่เปิดสอนในขณะนี้",
    enrollDate: "ไม่สามารถลงทะเบียนเรียนคอร์สนี้ได้ เนื่องจากไม่เปิดให้ลงทะเบียนในขณะนี้",

    // Finance Error
    pleaseFillAllFieldsCorrectly:"กรุณากรอกข้อมูลให้ครบถ้วนและสมบูรณ์",
    orderNotFound : "ไม่พบคำสั่งซื้อที่คุณต้องการ",

    // Schedule management error
    conflictScheudle:"ไม่สามารถแก้ไขได้ เนื่องจากโค้ชมีภาระการสอนในช่วงเวลาดังกล่าวแล้ว",
    conflictCheckIn: "ไม่สามารถแก้ไขตารางเรียนได้ เนื่องจากโค้ชที่สอนได้ลงชื่อเข้าสอนในคาบนี้แล้ว",

    // Change Role Error
    stillStudy:"ไม่สามารถเปลี่ยนบทบาทได้ เนื่องจากผู้ใช้นี้กำลังอยู่ระหว่างการเรียน",
    stillTeach:"ไม่สามารถเปลี่ยนบทบาทได้ เนื่องจากผู้ใช้นี้ยังมีชั่วโมงสอนอยู่",
    sameCateforyName:"ชื่ออาณาจักรนี้ถูกใช้ไปแล้ว",
    noStudentFound: "ไม่พบรายชื่อนักเรียนสำหรับคาบเรียนนี้",
    uploadImageAndVideo: "อัปโหลดได้เฉพาะรูปภาพและวิดีโอเท่านั้น",
    uploadOnlyImage: "อัปโหลดได้เฉพาะไฟล์รูปภาพเท่านั้น",
    successDel:"ลบข้อมูลสำเร็จ !",
    failDel:"ลบข้อมูลไม่สำเร็จ กรุณาตรวจสอบข้อมูลแล้วลองใหม่อีกครั้ง",
    cannotRegister: "สมัครสมาชิกไม่สำเร็จ กรุณาตรวจสอบข้อมูลและลองอีกครั้ง",
    dulicateUsername: "ขออภัย ชื่อผู้ใช้นี้ถูกใช้ไปแล้ว",
    dulicateEmail: "ขออภัย อีเมลนี้ถูกใช้ไปแล้ว",
    userNotFound: "ไม่พบผู้ใช้นี้ในระบบ กรุณาตรวจสอบอีกครั้ง",
    userAlreadyAdded:
      "คุณได้เพิ่มผู้ใช้นี้ในรายการผู้เรียนแล้ว กรุณาเลือกชื่อผู้ใช้อื่น",
    cannotAddSelf: "คุณไม่สามารถเพิ่มตัวเองได้ กรุณาเลือกชื่อผู้ใช้อื่น",
    cantAddNotStudent:
      "ไม่สามารถลงทะเบียนผู้ใช้นี้เป็นนักเรียนได้ เนื่องจากบทบาทของผู้ใช้ไม่เหมาะสม",
    cantAddAsParent:
      "ไม่สามารถเพิ่มผู้ใช้นี้เป็นผู้ปกครองของคุณได้ เนื่องจากบทบาทของผู้ใช้ไม่เหมาะสม",
    cantAddAsChild:
      "ไม่สามารถเพิ่มผู้ใช้นี้เป็นนักเรียนในการดูแลของคุณได้ เนื่องจากบทบาทของผู้ใช้ไม่เหมาะสม",
    coachNotFound: "ขออภัย ไม่พบโค้ชที่เปิดสอนในช่วงเวลานี้",
    courseNotFound: "ไม่พบคอร์สที่คุณสนใจ",
    packageNotFound:
      "ไม่พบแพ็กเกจที่เกี่ยวข้องกับคอร์สเรียนนี้ กรุณาติดต่อเจ้าหน้าที่เพื่อสอบถามข้อมูลเพิ่มเติม",
    packageOptionNotFound:
      "ไม่พบ {package} กรุณาติดต่อเจ้าหน้าที่เพื่อสอบถามข้อมูลเพิ่มเติม",
    selectPackage: "กรุณาเลือกแพ็กเกจก่อนดำเนินการต่อ",
    requiredField: "กรุณากรอกข้อมูลให้ครบถ้วนก่อนดำเนินการต่อ",

    loginField: "กรุณากรอกชื่อผู้ใช้และรหัสผ่านเพื่อเข้าสู่ระบบ",
    wrongUserPassword:
      "ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง กรุณาตรวจสอบข้อมูลอีกครั้ง",
    loginBeforeCart: "กรุณาเข้าสู่ระบบก่อนเพิ่มคอร์สเรียนลงตะกร้า",
    loginBeforeOrder: "กรุณาเข้าสู่ระบบก่อนสั่งซื้อคอร์สเรียน",
    plsTryAgain: "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง",
    saveFailed: "ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบและลองใหม่อีกครั้ง",
    wrongRoleAddChild:
      "เฉพาะผู้ใช้ที่มีบทบาทเป็น 'ผู้ใช้ทั่วไป' หรือ 'นักเรียน' เท่านั้น ที่สามารถเพิ่มเป็นนักเรียนภายใต้การดูแลได้ ",
    cantGetUserProfile: "เกิดปัญหาในการเข้าถึงข้อมูลผู้ใช้ กรุณาเข้าสู่ระบบใหม่อีกครั้ง",
    deleteFileError:"ไม่สามารถลบไฟล์ได้ เนื่องจากเกิดข้อผิดพลาด",
    uploadMaxFileSzie:"ไม่สามารถอัปโหลดไฟล์นี้ได้เนื่องจากมีขนาดเกินกว่า {count} MB",
    coachNotAllowCheckin:"ไม่สามารถเข้าสอนได้เนื่องจากไม่อยู่ในช่วงเวลาที่กำหนด",

  },
  forms: {
    registerFor: "ลงทะเบียน",
    registerReserve: "ลงทะเบียน (จอง)",
    personalInfo: "ข้อมูลส่วนตัว",
    usernameOrEmail: "ชื่อผู้ใช้ (ONE ID) / อีเมล",
    addParentInfo: "เพิ่มข้อมูลผู้ปกครอง",
    registerfor: "ลงทะเบียนให้",
    selfRegister: "ลงทะเบียนให้ตนเอง",
    otherRegister: "ลงทะเบียนให้ผู้อื่น",
    fillParentInfo: "กรอกข้อมูลผู้ปกครอง",
    learnerNumber: "ผู้เรียนคนที่ ",
    username: "ชื่อผู้ใช้",
    password: "รหัสผ่าน",
    confirmPassword: "ยืนยันรหัสผ่าน",
    firstname: "ชื่อ",
    lastname: "นามสกุล",
    nickname: "ชื่อเล่น",
    nickNameTH: "ชื่อเล่น (ไทย)",
    nickNameEN: "ชื่อเล่น (อังกฤษ)",
    phone: "เบอร์โทรศัพท์",
    email: "อีเมล",
    school: "โรงเรียน",
    gradeLevel: "ระดับชั้น",
    allergy: "โรคประจำตัว/อาหารที่แพ้",
    changeProfile: "เปลี่ยนรูปโปรไฟล์",
    edit: "แก้ไข",
    usernameOrEmailHint: "กรอกชื่อผู้ใช้ (ONE ID) /อีเมลของคุณ",
    usernameHint: "กรอกชื่อผู้ใช้",
    passwordHint: "กรอกรหัสผ่านของคุณ",
    confirmPassHint: "กรอกรหัสผ่านอีกครั้ง",
    emailHint: "กรอกอีเมลของคุณ",
    firstNameHint: "กรอกชื่อของคุณ",
    lastNameHint: "กรอกนามสกุลของคุณ",
    parentFirstnameHint: "กรอกชื่อผู้ปกครอง",
    parentLastnameHint: "กรอกนามสกุลผู้ปกครอง",
    nickNameHint: "กรอกชื่อเล่นของคุณ",
    phoneHint: "กรอกเบอร์โทรศัพท์ของคุณ",
    parentPhoneHint: "กรอกเบอร์โทรศัพท์ของผู้ปกครอง",
    gradeLevelHint: "กรุณาระบุระดับชั้น",
    schoolHint: "กรอกชื่อโรงเรียนของคุณ",
    allergyHint: "ระบุโรคประจำตัว/อาหารที่แพ้ (ถ้ามี)",
    addMore: "เพิ่มผู้เรียน",
    noAccount: "หากยังไม่มีบัญชีผู้ใช้กรุณา",
    createOneID: "ลงทะเบียน OneID",

    // --- Register Page ---
    firstNameTH: "ชื่อ (ไทย)",
    lastNameTH: "นามสกุล (ไทย)",
    firstNameEN: "ชื่อ (อังกฤษ)",
    lastNameEN: "นามสกุล (อังกฤษ)",
    firstNameHintTH: "กรอกชื่อของคุณด้วยภาษาไทย",
    lastNameHintTH: "กรอกนามสกุลของคุณด้วยภาษาไทย",
    firstNameHintEN: "กรอกชื่อของคุณด้วยภาษาอังกฤษ",
    lastNameHintEN: "กรอกนามสกุลของคุณด้วยภาษาอังกฤษ",
    agree: "ฉันเข้าใจและยอมรับ",
    termofService: "เงื่อนไขการให้บริการและนโยบายความเป็นส่วนตัว",
    forget: "ลืมรหัสผ่าน ?",

    // Select time & coach Page
    selectClassTime: "เลือกเวลาเรียน",
    selectTime: "เลือกช่วงเวลาเข้าเรียน",
    selectDay: "เลือกวันที่เรียน",
    selectCoach: "เลือกโค้ชผู้สอน",
    classDay: "วันที่เรียน",
    classTime: "เวลาเรียน",
    classCoach: "โค้ชที่เลือก",
    step: "ขั้นตอนที่",
    optional: "ถ้ามี",
    none: "ไม่มี",
    select: "เลือก",
    selected: "เลือกแล้ว",
  },

  label: {
    location:"ที่อยู่",
    contactUs:"ติดต่อเรา",
    manage: "จัดการ",
    filter: "ตัวกรอง",
    clear: "ล้างตัวกรอง",
    order: "ลำดับ",
    name: "ชื่อ-นามสกุล",
    nickname: "ชื่อเล่น",
    download: "ดาวน์โหลด",
    attendanceCount: "จำนวนครั้ง",
    classAttendance: "การเข้าชั้นเรียน",
    makeupClassDay: "วันเรียนชดเชย",
    progress: "พัฒนาการ",
    interests: "ความสนใจ",
    comment: "ความคิดเห็น",
    comments: "ความคิดเห็นเพิ่มเติม",
    noComment:"ไม่มีความคิดเห็นเพิ่มเติม...",
    addComment: "แสดงความคิดเห็น",
    moreComment: "ระบุความคิดเห็น...",
    viewComment: "ดูความคิดเห็น",
    clearForm: "ล้างข้อมูล",
    progressHomework: "พัฒนาการ / การบ้าน",
    uploadFiles: "อัปโหลดไฟล์แนบ",
    uploadType: "กรุณาเลือกไฟล์รูปภาพหรือวิดีโอที่ต้องการ",
    browseFile: "ค้นหาไฟล์แนบ",
    specify: "โปรดระบุ",
  },
  course: {
    noLearningJourney:"ไม่พบ Learning Journey",
    by: "โดย",
    hours: "{n} ชั่วโมง",
    price: "ราคา",
    package: "แพ็กเกจ",
    frequency: "{count} ครั้ง",
    capacity: "แพ็กเกจนี้เป็นสามารถรองรับผู้เรียนได้สูงสุด {count} ท่าน",
    certification: "Certification",
    dateAndTime: "วันและเวลา",
    privilege: "สิทธิพิเศษ",
    privilegeDetail: "สิทธิ์พิเศษสำหรับการสมัครรายเดือน / รายเทอม / รายปี",
    course: "คอร์ส",
    time: "เวลา",
    studentCount: "จำนวนผู้ลงทะเบียน",
    searchResult: "ผลลัพธ์การค้นหา",
    allCategory: "อาณาจักรทั้งหมด",
    courseCategory: "อาณาจักร",
    courseType: "ประเภทคอร์ส",
    allCourse: "คอร์สทั้งหมด",
    generalCourse: "คอร์สทั่วไป",
    shortCourse: "คอร์สระยะสั้น",
    coursePeriod: "ชั่วโมงเรียน / ครั้ง",
    registrationDate: "วันลงทะเบียนเรียน",
    classDate: "วันที่เรียน",
    classDays: "วันที่เรียน",
    classTime: "เวลาเรียน",
    coach: "ผู้สอน",
    selectCoach: "เลือกคุณครูผู้สอน",
    // Error
    alreadyCart: "คอร์สนี้อยู่ในตะกร้าของคุณแล้ว ไม่สามารถเพิ่มซ้ำได้",
    alreadyBuy: "คุณเคยซื้อคอร์สนี้แล้ว กรุณาตรวจสอบประวัติการซื้อ",
    alreadyReserve: "นักเรียนที่คุณลงทะเบียนไว้เคยจองคอร์สเรียนนี้แล้ว",
    successCart: "เพิ่มคอร์สนี้ในตะกร้าเรียบร้อยแล้ว",
    successReserve: "คุณได้ทำการจองคอร์สนี้เรียบร้อยแล้ว !",
    failCart: "เกิดข้อผิดพลาดในการเพิ่มคอร์ส กรุณาตรวจสอบแล้วลองใหม่อีกครั้ง",
    noCartProduct: "ไม่มีคอร์สในตะกร้าของคุณ",
    // New
    addChild: "ลงทะเบียนให้บุตรหลาน",
    addChildOneID: "บัญชีOne ID",
    addChildNoID: "กรอกข้อมูลส่วนตัว",
    hintAddChildNoID:
      "การเพิ่มผู้เรียนด้วยวิธีนี้ ระบบจะไม่สร้างบัญชีให้แก่นักเรียน ผู้ปกครองจะต้องเป็นผู้จัดการข้อมูล เช่น การชำระเงิน การติดตามตารางเรียนแทน",
    reserveWarning:
      "ขณะนี้เหลือที่นั่งว่าง {count} ที่นั่ง หากคุณเลือกจำนวนนักเรียนเกินกว่าที่คอร์สกำหนด หลังชำระเงิน ระบบจะลงทะเบียนผู้เรียนทั้งหมดในสถานะ “จองคอร์ส”แทน หากต้องการซื้อคอร์ส กรุณาเลือกจำนวนนักเรียนไม่เกิน {count} คน",
    reserve: "จองคอร์ส",
    noreserveFound: "ไม่พบประวัติการจอง",
    noCourseFound: "ไม่พบประวัติการลงทะเบียนเรียน",

    noSeatAvailable:
      "คอร์สนี้มีผู้ลงทะเบียนครบแล้ว หากต้องการ <b>จองคอร์ส</b> กรุณากดปุ่มถัดไป หรือ <a href='/course' >คลิกที่นี่</a> เพื่อดูคอร์สอื่น",
  },
  hour: {
    _1hr: "0-1 ชั่วโมง",
    _2hr: "1-2 ชั่วโมง",
    _3hr: "2-4 ชั่วโมง",
    _4hr: "4 ชั่วโมงขึ้นไป",
  },
  day: {
    mon: "วันจันทร์",
    tue: "วันอังคาร",
    wed: "วันพุธ",
    thu: "วันพฤหัสบดี",
    fri: "วันศุกร์",
    sat: "วันเสาร์",
    sun: "วันอาทิตย์",
  },
  shortDay: {
    mon: "จ.",
    tue: "อ.",
    wed: "พ.",
    thu: "พฤ.",
    fri: "ศ.",
    sat: "ส.",
    sun: "อา.",
  },

  profile: {
    plsFillForm:"เพื่อให้สามารถซื้อคอร์สและใช้งานระบบได้ กรุณากรอกข้อมูลส่วนตัวของคุณ",
    dataPrivacyIns:"ข้อมูลของคุณจะถูกเก็บเป็นความลับ และใช้เพื่อการให้บริการเท่านั้น",
    notOneId: 'ยังไม่ได้ผูกบัญชี ONE ID',
    addParent: "เพิ่มผู้ปกครอง",
    addStudent: "เพิ่มนักเรียน",
    viewProfile: "ดูข้อมูลส่วนตัว",
    studentProfile: "ข้อมูลนักเรียน",
    certiNotFound: "ไม่พบข้อมูลเกียรติบัตรและการแข่งขัน",
    plsAddFile:"กรุณาแนบไฟล์เกียรติบัตร/การแข่งขัน",
    plsOnlyOneFile:"กรุณาอัปโหลดไฟล์แนบไม่เกิน 1 ไฟล์",
    general: "ทั่วไป",
    password: "รหัสผ่าน",
    language: "ภาษา",
    course: "คอร์ส",
    myCourse: "คอร์สของฉัน",
    myReserve: "คอร์สที่จอง",
    delCertificate:"ลบเกียรติบัตร",
    editCertificate:"แก้ไขเกียรติบัตร/การแข่งขัน",
    competitionsAndCertificates: "เกียรติบัตรและการแข่งขัน",
    confirmCertificate:"คุณต้องการเพิ่มเกียรติบัตรนี้ใช่หรือไม่ ?",
    confirmEditCertificate:"ยืนยันการแก้ไขข้อมูลเกียรติบัตรนี้ใช่หรือไม่ ?",
    confirmDelCertificate:"ยืนยันการลบข้อมูลเกียรติบัตรนี้ใช่หรือไม่ ?",
    addCertificate: "เพิ่มเกียรติบัตรหรือการแข่งขัน",
    competitionNameHint: "ระบุชื่อการแข่งขัน",
    competitionName: "ชื่อการแข่งขัน/เกียรติบัตร",
    competitionDate: "วันที่แข่งขัน",
    uploadCompetition: "อัปโหลดไฟล์เกียรติบัตรและการแข่งขัน",
    competitionDateHint: "ระบุวันที่แข่งขัน",
    parentInformation: "ข้อมูลผู้ปกครอง",
    courses: "คอร์สเรียน",
    privacyPolicy: "นโยบายการคุ้มครองข้อมูลส่วนบุคคล",
    termsAndConditionsofService: "ข้อกำหนดการและเงื่อนไขการใช้บริการ",
    noParent: "ไม่พบรายชื่อผู้ปกครอง",
    noStudent: "ไม่มีรายชื่อนักเรียนในความดูแล",
    successUpdateProfile: "อัปเดตโปรไฟล์สำเร็จแล้ว",
    deletedParent: "ผู้ใช้นี้ถูกถอดออกจากการเป็นเรียบร้อยแล้ว!",
    addedParent: "ผู้ใช้นี้ถูกเพิ่มเป็นผู้ปกครองเรียบร้อยแล้ว!",
    deletedStudent:
      "ผู้ใช้นี้ถูกถอดออกจากการเป็นนักเรียนภายใต้การดูแลแล้ว!",
    addedStudent: "ผู้ใช้นี้ถูกเพิ่มเป็นนักเรียนภายใต้การดูแลแล้ว!",
    doublyParent: "ผู้ใช้นี้ได้ลงทะเบียนเป็นผู้ปกครองอยู่แล้ว",
    doublyStudent: "ผู้ใช้นี้ได้ลงทะเบียนเป็นนักเรียนอยู่แล้ว",
    addYourSelf: "คุณไม่สามารถกำหนดผู้ใช้นี้เป็นผู้ปกครองได้",
  },
  Cart: {
    coach: "โค้ช",
    userName: "ชื่อผู้เรียน",
    classDate: "วันที่เรียน",
    classTime: "เวลาเรียน",
    showMore: "แสดงรายชื่อนักเรียน",
    hide: "ซ่อนรายชื่อนักเรียน",
    warningDelete: "คุณแน่ใจหรือไม่ว่าต้องการลบคอร์สนี้ออกจากตะกร้า",
    confirmDelete: "ใช่, ลบเลย!",
    noItemsSelected: "ไม่มีสินค้าที่เลือก",
    paymentSuccess: "ชำระเงินสำเร็จ!",
    paymentFailed: "ชำระเงินไม่สำเร็จ!",
    paymentError: "เกิดข้อผิดพลาดในการชำระเงิน!",
    cancelDelete: "ยกเลิก",
    deleteSuccess: "ลบสินค้าเรียบร้อย!",
    noHistory: "ยังไม่มีประวัติการสั่งซื้อ",
    startLearn: "เลือกคอร์สที่สนใจ และลงทะเบียนเรียนได้เลย!",
    seeAllCourse: "ดูคอร์สทั้งหมด",
    seeCart: "ดูตะกร้าสินค้า",
  },
  historyOrder: {
    classDate: "วันที่เรียน",
    classTime: "เวลาเรียน",
    coach: "โค้ช",
    userName: "ชื่อผู้เรียน",
    allStatus: "ทั้งหมด",
    pendingStatus: "รอชำระเงิน",
    compiledStatus: "ชำระเงินแล้ว",
    cancelStatus: "ยกเลิกคำสั่งซื้อ",
    successCancel: "ยกเลิกคำสั่งซื้อนี้แล้ว!",
    confirmCancel:"คุณต้องการยกเลิกคำสั่งซื้อนี้หรือไม่ ?"
  },
  sweetAlert: {
    reserveQa:"คุณต้องการจองคอร์สนี้ใช่หรือไม่ ?",
    error: "เกิดข้อผิดพลาด",
    areYouSure: "คุณแน่ใจหรือไม่?",
    deleteParent: "ยืนยันการลบผู้ใช้นี้จากการเป็นผู้ปกครองของคุณ",
    deleteStudent: "ยืนยันการลบผู้ใช้นี้จากการเป็นนักเรียนในการดูแลของคุณ",
    deleteCourse: "ยืนยันการลบคอร์สนี้",
    successEditAlert:"บันทึกการแก้ไขเรียบร้อยแล้ว",
    deleteCategory:
      "ยืนยันการลบอาณาจักรนี้",
    confirm: "ยืนยัน",
    cancel: "ยกเลิก",
    cancelCourse: "คุณต้องการยกเลิกการซื้อคอร์สนี้ ?",
    warnCancelCourse: "หากคุณยกเลิก ข้อมูลที่กรอกจะไม่ถูกบันทึก",
    yes: "ใช่, ยกเลิกเลย!",
    no: "ไม่, ดำเนินการต่อ",
  },

  attendanceStatus: {
    onTime: "ตรงเวลา",
    late: "สาย",
    absent: "ขาด",
    leave: "ลา",
    emergencyLeave: "ลาฉุกเฉิน",
    attendanceStatus: "สถานะการเข้าชั้นเรียน",
  },
  checkInStatus: {
    PUNCTUAL: "ตรงเวลา",
    LATE: "สาย",
    ABSENT: "ขาด",
    LEAVE: "ลา",
    EMERGENCY_LEAVE: "ลาฉุกเฉิน",
    NOT_CHECKIN: "ไม่ระบุ",
  },
  coach: {
    noReportFound:"ไม่พบข้อมูลการเรียนการสอนของคอร์สนี้",
    evaluationDetail:"รายละเอียดการประเมิน",
    learner: "ผู้เรียน",
    hintInterestField: "ความสนใจของผู้เรียน...",
    markAttendance: "การเข้าร่วมชั้นเรียน",
    evaluation: "การประเมิน",
    evaluationStd: "ประเมินนักเรียน",
    evaluationPoten: "ประเมินศักยภาพ",
    lessonRecord: "บันทึกการสอน",
    classSummary: "สรุปการสอน",
    summaryAndHomework:"สรุปการสอน/การบ้าน",
    progress: "พัฒนาการ",
    progressLev: "ระดับพัฒนาการ",
    attentionLev: "ระดับความสนใจ",
    attention: "ความสนใจ",
    teachingRec: "บันทึกการเรียนการสอน",
    selectCourse: "เลือกคอร์ส",
    selectDate: "เลือกเวลา",
    selectTeachRec: "เลือกคอร์สเพื่อดูบันทึกการเรียนการสอน",
    studentList: "รายชื่อนักเรียน",
    leaveRec: "บันทึกการลา",
    teachingInf: "ข้อมูลการสอน",
    noClass: "ไม่มีการสอนในวันดังกล่าว",
    warnNoStudentReport: "ไม่พบข้อมูลการประเมินนักเรียน",
    warnNoPotentialReport: "ไม่พบข้อมูลการประเมินศักยภาพของนักเรียน",
    warnNoSummaryReport: "ไม่พบข้อมูลบันทึกสรุปการสอน",
    cantEvaluate: "ไม่สามารถประเมินศักยภาพได้",
    cantEvaluateClass: "ไม่สามารถประเมินนักเรียนได้",
    cantEvaluateClassIns: "เนื่องจากไม่มีนักเรียนเข้าเรียนในคลาสนี้",
    cantEvaluateIns:
      "ระบบจะเปิดให้ประเมิน หลังจากมีนักเรียนที่เรียนจบคอร์สนี้แล้วในวันดังกล่าว",
    notAllCheckin: "กรุณาเลือกสถานะการเข้าร่วมของนักเรียนทุกคนก่อนบันทึก",
    allCheckin: "บันทึกสถานะการเข้าชั้นเรียนของนักเรียนแล้ว",
    saveEvaluation: "บันทึกการประเมินแล้ว",
    saveReport: "บันทึกสรุปการสอนแล้ว",
    errorNotAllEvaluate: "กรุณาประเมินนักเรียนให้ครบทุกคนก่อนทำการบันทึก",
  },
  drawerMenu: {
    overview: "ทั่วไป",
    logout: "ออกจากระบบ",
    classSchedule: "ตารางเรียน",
    coachMenu: "การจัดการการสอน",
    adminMenu: "หน้าจัดการแอดมิน",
    userMenu: "หน้าผู้ใช้ทั่วไป",
    parentInfo: "ข้อมูลผู้ปกครอง",
    studentInfo: "นักเรียนในการดูแล",
    myCourse: "คอร์สเรียนของฉัน",
    course: "คอร์สเรียน",
    portfolio: "แฟ้มสะสมผลงาน",
    contestCertificate: "เกียรติบัตรและการแข่งขัน",
    password: "รหัสผ่าน",
    language: "ภาษา",
    myAccount: "ข้อมูลส่วนตัว",
    myPurchase: "ประวัติการลงทะเบียน",
    policy: "นโยบาย",
    term: "เงื่อนไขการใช้บริการ",
    privacyPolicy: "นโยบายการคุ้มครองข้อมูลส่วนบุคลล",
    setting: "การตั้งค่า",
    notification: "การแจ้งเตือน",
  },
  forgotPassword: {
    forgotPassword: "ลืมรหัสผ่าน ?",
    changePassword: "เปลี่ยนรหัสผ่าน",
    newPassword: "รหัสผ่านใหม่",
    confirmPassword: "ยืนยันรหัสผ่าน",
    bySMS: "ยืนยันการเปลี่ยนรหัสผ่านเบอร์โทรศัพท์ (SMS)",
    byEmail: "ยืนยันการเปลี่ยนรหัสผ่านด้วยอีเมล",
    changeByEmail: "เปลี่ยนรหัสผ่านด้วยอีเมล",
    changeBySMS: "เปลี่ยนรหัสผ่านเบอร์โทรศัพท์ (SMS)",
    otpViaEmail:
      "รหัสยืนยันถูกส่งไปยังอีเมลของคุณแล้ว กรุณากรอกรหัสเพื่อดำเนินการต่อ",
    otpViaSMS:
      "รหัส OTP ถูกส่งไปยังเบอร์โทรศัพท์ของคุณแล้ว กรุณากรอกรหัสเพื่อดำเนินการต่อ",
    checkSMS: "ตรวจสอบ SMS ของคุณ",
    checkEmail: "ตรวจสอบอีเมลของคุณ",
    dontReciveOTP: "ไม่ได้รับรหัสยืนยัน ?",
    resetPassword: "รีเซ็ทรหัสผ่าน",
    resetRule: "กรุณาตั้งรหัสผ่านใหม่ให้ตรงตามเกณฑ์ที่กำหนดเพื่อความปลอดภัย",
    resend: "ส่งอีกครั้ง",
    passwordRules: "รหัสผ่านของคุณต้องประกอบด้วย",
    backToHome: "กลับสู่หน้าหลัก",
    backToLogin: "กลับสู่หน้าเข้าสู่ระบบ",
    otpFail: "ขออภัย เกิดข้อผิดพลาดในการส่งรหัส OTP กรุณาลองใหม่อีกครั้ง",
    wrongUserPhone:
      "ชื่อผู้ใช้หรือเบอร์โทรศัพท์ไม่ถูกต้อง กรุณาตรวจสอบและลองใหม่อีกครั้ง",
    wrongPhoneNumber:
      "เบอร์โทรศัพท์ที่กรอกไม่ถูกต้อง กรุณาตรวจสอบและลองใหม่อีกครั้ง",
    wrongUserEmail:
      "ชื่อผู้ใช้หรืออีเมลไม่ถูกต้อง กรุณาตรวจสอบและลองใหม่อีกครั้ง",
    wrongEmail: "อีเมลที่กรอกไม่ถูกต้อง กรุณาตรวจสอบอีเมลและลองใหม่อีกครั้ง",
    wrongOTP: "รหัส OTP ที่กรอกไม่ถูกต้อง กรุณาตรวจสอบและลองใหม่อีกครั้ง",
    successChangePass: "คุณได้ทำการเปลี่ยนรหัสผ่านเรียบร้อยแล้ว",
    sucessSentEmail: "ลิงก์สำหรับการเปลี่ยนรหัสผ่านถูกส่งไปยังอีเมลของคุณแล้ว",
  },
  pluralize: {
    person: "{count} คน",
    student:"{count} คน",
    course: "{count} คอร์ส",
    bahtPerson: "{count} บาท/คน",
  },
  learnerClass: {
    period:"คาบที่",
    coach: "โค้ช",
    development: "ระดับพัฒนาการ",
    Interest: "ระดับความสนใจ",
    showMore: "ดูเพิ่มเติม",
    showLess:"ดูน้อยลง",
    comments: "ความคิดเห็น",
    studytime: "เวลาเรียน",
    studyinformation: "ข้อมูลการเรียน",
    selectAll: "เลือกทั้งหมด",
    cancel: "ยกเลิก",
    downlode: "ดาวน์โหลดผลการประเมิน",
    confirmDownload: "คุณต้องการดาวน์โหลดผลการประเมินหรือไม่ ?",
    confirm: "ยืนยัน",
    evaluationResults: "ผลการประเมินศักยภาพ",
    AssignedWork: "งานที่ได้รับมอบหมาย",
    Reserved: "จองแล้ว",
    time: "ครั้ง",
    downloadFile: "ดาวน์โหลดไฟล์",
    noClassCheckIn: "นักเรียนยังไม่เคยเข้าชั้นเรียนในคอร์สนี้",
    selectChild: "กรุณาเลือกผู้เรียนเพื่อดูตารางเรียน",
    selectChildCourse: "กรุณาเลือกผู้เรียนเพื่อดูรายการคอร์สเรียน",
  },
  learnnerSchedules: {
    Day: "วัน",
    Week: "สัปดาห์",
    Month: "เดือน",
    Time: "เวลา",
    Schedules: "ตารางเรียน",
    detail: "รายละเอียด",
    notstudy: "ยังไม่มีประวัติการเรียน",
    seeDetail: "ดูรายละเอียด",
  },
  coursesBooked: {
    classDate: "วันที่เรียน",
    classTime: "เวลาเรียน",
    coach: "โค้ช",
    userName: "ชื่อผู้เรียน",
    allStatus: "ทั้งหมด",
    pendingStatus: "รอชำระเงิน",
    compiledStatus: "ชำระเงินแล้ว",
    cancelStatus: "ยกเลิกคำสั่งซื้อแล้ว",
    courseHourPerTime: "ชั่วโมง/ครั้ง",
  },
  status: {
    ALL: "ทั้งหมด",
    PENDING: "รออนุมัติ",
    APPROVE: "อนุมัติ",
    REJECT: "ไม่อนุมัติ",
    CANCEL: "ยกเลิก",
    CONFIRM: "ยืนยัน",
  },
  coachLeave: {
    selectTeachingInformation: "เลือกข้อมูลการสอน",
    courseName: "ชื่อคอร์ส",
    leaveForm: "แบบฟอร์มการลา",
    confirmLeave: "ยืนยันการลา ?",
    confirmCancel: "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกใบลานี้?",
    successLeave: "ส่งแบบฟอร์มการลาสำเร็จ !",
    cancelLeave: "ยกเลิกการลา",
    successCancelLeave: "ยกเลิกการลาสำเร็จ !",
    editSubClss:"แก้ไขรายละเอียดการสอนชดเชย",
    list: "รายการ",
    index: "ลำดับ",
    leaveDate: "วันที่ลา",
    startDate: "วันที่เริ่ม",
    endDate: "วันที่สิ้นสุด",
    leaveTypeCode: "ประเภทการลา",
    remarkLeave: "รายละเอียดการลา",
    leaveDetail: "รายละเอียดแบบฟอร์มการลา",
    status: "สถานะ",
    detail: "รายละเอียด",
    period: "ช่วงเวลา",
    fullTime: "ทั้งวัน",
    startTime: "เวลาเริ่ม",
    endTime: "เวลาสิ้นสุด",
    makeUpTime: "เวลาชดเชย",
    remarkReject: "สาเหตุการปฎิเสธ",
    uploadAttachments: "อัปโหลดไฟล์แนบ",
    attachments: "ไฟล์แนบ",
    // ประเภทการลา
    SICK: "ลาป่วย",
    BUSSINESS: "ลากิจ",
    ANNUAL: "ลาพักร้อน",
    MULTERNITY: "ลาคลอด",
    teachingDate: "วันที่สอน",
    newTeachingDate: "วันที่สอนชดเชย",
    newTeachingTime: "เวลาสอนชดเชย",
    subTeacher: "ครูสอนแทน",
    course: "คอร์ส",
    warningRemark: "กรุณากรอกรายละเอียดการลา",
  },
  adminDrawer: {
    dashboard: "แดชบอร์ด",
    userManage: "การจัดการผู้ใช้",
    manageSchedule: "จัดการตารางสอน",
    courseManage: "การจัดการคอร์ส",
    manageAllCourses: "จัดการคอร์ส",
    createCourse: "สร้างคอร์สเรียน",
    manageBookings: "จัดการการจอง",
    regions: "อาณาจักร",
    manageCategory: "การจัดการอาณาจักร",
    createCategory: "สร้างอาณาจักร",
    finance: "การเงิน",
    leaveApproval: "การอนุมัติการลา",
    manageCheckIns: "การจัดการเช็คอิน",
    checkInByOrder: "เช็คอินตามออร์เดอร์",
    checkInByCourse: "เช็คอินตามคอร์ส",
    manageEvents: "การจัดการอีเว้นท์",
    editUser: "จัดการผู้ใช้",
    importUsers: "นำเข้าผู้ใช้",
    addStudent: "การเพิ่มผู้เรียน",
    survey: "การประเมินความพึงพอใจ",
    events: "จัดการอีเว้นท์",
    attendance: "เช็คชื่อนักเรียนย้อนหลัง",

  },
  formError:{
    courseName:"ชื่อคอร์สนี้ถูกใช้ไปแล้ว"
  },

  createCourse: {
    deletePackagePlan:"คุณต้องการลบรูปแบบแพ็กเกจนี้หรือไม่?",
    uploadCourseImg: "อัปโหลดภาพหน้าปกคอร์ส",
    uploadImgIns:
      "ควรอัปโหลดรูปขนาด 1024 x 576 px (16:9) ขนาดไฟล์ไม่เกิน 1 MB และรองรับเฉพาะไฟล์ JPG หรือ PNG เท่านั้น",
    courseNameTH: "ชื่อคอร์ส (ภาษาไทย)",
    courseNameEN: "ชื่อคอร์ส (ภาษาอังกฤษ)",
    courseLocation: "สถานที่เรียน",
    studentCapacity: "จำนวนผู้เรียนที่เปิดรับสมัคร",
    classPeriod: "ระยะเวลาเรียน (ชั่วโมง/ครั้ง)",
    coursePrice: "ราคาคอร์ส/คน",
    courseReserve: "การจองคอร์ส",
    selectCategory: "เลือกอาณาจักร",
    registDateRange: "วันที่รับสมัคร",
    studyDateRange: "วันที่เรียน",
    courseOpenDate: "วันที่เปิดคอร์ส",
    reserveDateRange: "ช่วงวันที่เปิดจอง",
    teachDateRange: "ช่วงวันที่สอน",
    baht: "บาท",
    discount: "ส่วนลด/คน",
    dateAndTime: "วันและเวลา",
    selectStartDate: "เลือกวันที่เริ่มต้น",
    selectEndDate: "เลือกวันที่สิ้นสุด",
    selectDay: "ช่วงวันที่เรียน",
    uploadJourney: "อัปโหลดรูปภาพและวิดีโอ Learning Journey",
    uploadJourneyIns:"ควรอัปโหลดรูปภาพหรือวิดีโอที่มีขนาดไม่เกิน 10 MB และหากเป็นวิดีโอ จะรองรับเฉพาะไฟล์ MP4 เท่านั้น",
    addLink: "เพิ่มลิงก์",
    addMore: "เพิ่มรายการ",
    reserveBefore: "ช่วงวันที่เปิดจอง",
    otherDetail: "รายละเอียดเพิ่มเติม",
    preRegister: "เปิดจองคอร์สล่วงหน้าก่อนเริ่มเรียน",
    timeAndCoach: "ช่วงเวลาและโค้ช",
    packAndPrivilage: "แพ็กเกจ",
    privilageAndJourey:"สิทธิพิเศษ",
    addMoreCoach: "เพิ่มโค้ช",
    coachNo: "โค้ชคนที่",
    coachCapacity: "จำนวนผู้เรียนที่รับได้ (คน/คาบ)",
    coachOepn: "เปิดสอน",
    uploadPrivilage: "อัปโหลดสิทธิพิเศษ",
    uploadPrivilageIns:
      "ควรอัปโหลดรูปที่มีขนาด 1024 x 576 (16:9) และขนาดไฟล์ไม่เกิน 1 MB โดยต้องเป็นไฟล์ JPG หรือ PNG เท่านั้น",
    packageNo: "แพ็กเกจที่",
    packageType: "ประเภทแพ็กเกจ",
    packagePlan: "รูปแบบแพ็กเกจ",
    packagePlanNo: "ตัวเลือกแพ็กเกจที่",
    addPackage: "เพิ่มแพ็กเกจ",
    addPackagePlan: "เพิ่มตัวเลือกแพ็กเกจ",
    selectPlan: "เลือกรูปแบบแพ็กเกจ",
    packageLimit: "จำนวนนักเรียนที่รองรับได้ (คน)",
    sessionReq: "จำนวนครั้งที่ต้องเข้าเรียน",
    selectSessionReq: "ระบุจำนวนครั้งที่ต้องเข้าเรียน",
    createCourse: "สร้างคอร์ส",
    uploadURL: "เพิ่มลิงก์วิดีโอ",
    uploadURLIns: "https://www.youtube.com/example",
    selectDayIns: "เลือกช่วงวันที่สอน (จันทร์ - อาทิตย์)",

    //Alert + Error Handler
    successEdit: "ข้อมูลคอร์สถูกแก้ไขเรียบร้อยแล้ว",
    successCreate: "สร้างคอร์สสำเร็จ!",
    successSave: "บันทึกข้อมูลเรียบร้อยแล้ว",
    successAdd: "เพิ่มคอร์ส สำเร็จ!",
    successDelete: "ลบคอร์ส สำเร็จ!",
    failUpdateStatus: "ไม่สามารถเปลี่ยนสถานะของคอร์สนี้",
    deleteCategoryImg:"คุณต้องการลบภาพปกของอาณาจักรนี้หรือไม่ ?",
    deleteCourseImg:"คุณต้องการลบรูปนี้หรือไม่ ?",
    deleteThisFile:"คุณต้องการลบไฟล์นี้หรือไม่ ?"
  },
  courseCoach: {
    coachName: "ชื่อโค้ช",
    dateAndTeachTime: "วันและเวลาสอน",
    addTeachingTime: "เพิ่มเวลาสอน",
    delTeachingTime: "ลบเวลาสอน",
    addteachingDay: "เพิ่มวันที่สอน",
    deleteCourseCoach: "ยืนยันการลบโค้ชออกจากคอร์สนี้หรือไม่",
    confirmEditCoach: "ยืนยันการเปลี่ยนแปลงข้อมูลโค้ช",
    conEditCoachAlreadyTeach:
      "การเปลี่ยนแปลงนี้อาจส่งผลต่อตารางเรียน โปรดยืนยันก่อนดำเนินการต่อ",
    atLeastOneCoach: "ไม่สามารถลบโค้ชได้ เนื่องจากต้องมีโค้ชอย่างน้อย 1 คน",
    alreadyTeach: "ไม่สามารถลบได้ เพราะมีนักเรียนเรียนกับโค้ชคนนี้อยู่",
    successEdit: "ข้อมูลโค้ชถูกแก้ไขเรียบร้อยแล้ว",
    successAdd: "เพิ่มโค้ช สำเร็จ!",
    successDelete: "ลบโค้ช สำเร็จ!",
  },
  category: {
    manageCategory: "จัดการอาณาจักร",
    categoryImg: "ภาพหน้าปกอาณาจักร",
    uploadCategoryImg: "อัปโหลดภาพหน้าปกอาณาจักร",
    categoryTH: "ชื่ออาณาจักร (ภาษาไทย)",
    categoryEN: "ชื่ออาณาจักร (ภาษาอังกฤษ)",
    taughtBy: "สอนโดย",
    categoryDetail: "รายละเอียดอาณาจักร",
    description: "รายละเอียดเพิ่มเติม",
    addCategory: "เพิ่มอาณาจักร",
    categoryName: "อาณาจักร",
    //Alert + Error Handler
    successEdit: "ข้อมูลอาณาจักรถูกแก้ไขเรียบร้อยแล้ว",
    successAdd: "เพิ่มอาณาจักร สำเร็จ!",
    successDelete: "ลบอาณาจักร สำเร็จ!",
    successOpen: "คุณได้เปิดการมองเห็นของอาณาจักรนี้แล้ว",
    successClose: "คุณได้ปิดการมองเห็นของอาณาจักรนี้แล้ว",
    failUpdateStatus:
      "ไม่สามารถอัปเดทสถานะของอาณาจักรนี้ได้ กรุณาลองใหม่อีกครั้ง",
  },
  courseStatus: {
    open: "เปิดคอร์ส",
    close: "ปิดคอร์ส",
    tempClose: "ปิดชั่วคราว",
    openReserve: "เปิดจองคอร์ส",
    draft:"แบบร่าง",

    // StudentList Reserve Status
    pending: "รอการติดต่อ",
    cancel: "ยกเลิกการจอง",
    complete: "ติดต่อแล้ว",
  },
  studentList: {
    goToMyCoursePage: "ดูคอร์สเรียนของฉัน",
    goToStudentCoursePage: "ดูคอร์สเรียนของนักเรียน",
    attendanceStatus: "สถานะการเข้าชั้นเรียน",
    checkIn:"เข้าเรียนแล้ว",
    studentList: "รายชื่อนักเรียน",
    coachList: "รายชื่อโค้ช",
    fullname: "ชื่อ-สกุล",
    ongoing: "กำลังศึกษา",
    completed: "จบคอร์สแล้ว",
    reserve: "จองคอร์สไว้",
    export: "ดาวน์โหลดข้อมูล",
    noStudent: "ไม่พบรายชื่อนักเรียน",
    reserveDate: "วันที่จอง",
    viewEvaluation: "ดูผลการประเมิน",
    classEvaluation: "ผลการประเมินนักเรียน",
    courseEvaluation: "ผลการประเมินศักยภาพ",
    viewProfile: "ดูโปรไฟล์",
    searchStudent: "ค้นหานักเรียน...",
    studentListView: "แสดงตามรายชื่อ",
    classView: "แสดงตามวันที่เรียน",
  },
  notification: {
    noMessage: "ไม่พบข้อความแจ้งเตือน",
    errorTitle: "เกิดข้อผิดพลาด!",
    noSeatAvailable: "ขออภัย คอร์สดังกล่าวมีผู้ลงทะเบียนครบแล้ว",
    seatExsit:
      "ผู้เรียนลงทะเบียนคอร์สดังกล่าวอยู่แล้ว ไม่สามารถลงทะเบียนซ้ำได้",
  },
  userRole: {
    ADMIN: "แอดมิน",
    PARENT: "ผู้ปกครอง",
    STUDENT: "นักเรียน",
    GUEST: "ผู้ใช้ทั่วไป",
  },
  user: {
    selectRole: "เลือกบทบาท..",
    selectAll: "เลือกบทบาททั้งหมด",
    allUser: "ผู้ใช้งานทั้งหมด",
    role: "บทบาท",
    user: "ผู้ใช้ทั่วไป",
    admin: "ผู้ดูแลระบบ",
    parent: "ผู้ปกครอง",
    coach: "โค้ช",
    student: "นักเรียน",
    addUser: "เพิ่มผู้ใช้",
    contactedAll: "ติดต่อแล้วทั้งหมด",
    edit: "แก้ไขข้อมูลส่วนตัว",
    userRole: "บทบาทของผู้ใช้",
    successEditRole: "เปลี่ยนบทบาทของผู้ใช้สำเร็จ !",
    deleteUser:
      "การดำเนินการนี้จะลบผู้ใช้ออกจากระบบอย่างถาวร\nและไม่สามารถกู้คืนได้",
    successDelete: "ผู้ใช้นี้ถูกลบออกจากระบบเรียบร้อยแล้ว",
    failedDelete: "ไม่สามารถลบผู้ใช้นี้ได้ กรุณาลองใหม่อีกครั้ง",
    successAdd:"เพิ่มผู้ใช้นี้เข้าสู่ระบบเรียบร้อยแล้ว!",
  },
  enroll: {
    confirmAddStudent:"ยืนยันการเพิ่มผู้เรียน ?",
    plsSelectStudent:"กรุณาเลือกผู้เรียนอย่างน้อย 1 คน",
    plsSelectCourse:"กรุณาเลือกคอร์สเรียนอย่างน้อย 1 คอร์ส",
    remark:"หมายเหตุ",
    addLearner: "เพิ่มผู้เรียน",
    chooseLearner: "เลือกผู้เรียน",
    chooseLearnerIns: "ค้นหาและเลือกนักเรียน",
    chooseCourse: "เลือกคอร์ส",
    chooseCourseIns: "เลือกคอร์สที่จะลงทะเบียน",
    payment: "การชำระเงิน",
    paymentIns: "กรอกรายละเอียดหรือส่งแจ้งเตือนการชำระเงิน",
    alreadyPurchase: "ชำระเงินเรียบร้อยแล้ว",

    sendPaymentReminder: "ส่งแจ้งเตือนชำระเงิน",
    searchCourse: "ค้นหาคอร์ส...",
    addOnDiscount: "ส่วนลดเพิ่มเติม/คน",
    selectCoachAndTime: "เลือกโค้ชและเวลาเรียน",
    startClassDate: "วันที่เริ่มเรียน",
    successEnroll: "เพิ่มผู้เรียนเรียบร้อยแล้ว",
    failEnroll:
      "ไม่สามารถเพิ่มผู้เรียนได้ กรุณาตรวจสอบข้อมูลและลองใหม่อีกครั้ง",
  },
  payment: {
    paymentSuccess: "การชำระเงินสำเร็จ",
    paymentFailed: "การชำระเงินไม่สำเร็จ",
    paymentPending: "รอการชำระเงิน",
    paymentCancelled: "การชำระเงินถูกยกเลิก",
    orderID: "หมายเลขคำสั่งซื้อ",
    paymentDate: "วันที่ทำรายการ",
    paymentTime: "เวลาทำรายการ",
    paymentBy: "ชำระโดย",
    paymentAmount: "จำนวนเงินที่ชำระ",
    bank: "โอนผ่านธนาคาร",
    schoolBank:"โอนเงินเข้าบัญชีโรงเรียน",
    qrPayment:"QR Payment",
    cash: "เงินสด",
    creditCard: "บัตรเครดิต/เดบิต",
    method: "ช่องทางการชำระเงิน",
    receivedBy: "ผู้รับเงิน",
  },
  paymentStatus: {
    total: "ทั้งหมด",
    pending: "รอการชำระเงิน",
    success: "ชำระเงินแล้ว",
    cancel: "ยกเลิกการชำระเงิน",
    failed: "เกิดข้อผิดพลาด",
  },
  finance: {
    confirmPayment:"ยืนยันการชำระเงิน",
    confirmSendNoti:"ยืนยันการส่งแจ้งเตือนการชำระเงิน ?",
    successNoti:"ส่งแจ้งเตือนการชำระเงินสำเร็จ !",
    errorNoti:"เกิดข้อผิดพลาด ไม่สามารถส่งแจ้งเตือนการชำระเงินได้",
    autoCancelIns:"ยกเลิกอัตโนมัติหากไม่ชำระเงินภายใน 3 วันหลังจากวันที่สั่งซื้อ",
    qaConfirmPayment:"ต้องการยืนยันการชำระเงินใช่หรือไม่ ?",
    successConfirm:"ยืนยันการชำระเงินสำเร็จ",
    selectPaymentType:"เลือกช่องทางการชำระเงิน",
    errorConfirm:"ไม่สามารถยืนยันการชำระเงินได้",
    finance: "การเงิน",
    createdBy:"ผู้ทำรายการ",
    totalItem:"สรุปรายการ",
    genReciept:"ออกใบเสร็จฉบับเต็ม",
    courseList:"รายการคอร์สเรียน",
    paymentHistory: "ประวัติการชำระเงิน",
    paymentStatus: "สถานะการชำระเงิน",
    paymentDate: "วันที่ชำระเงิน",
    canceltDate: "วันที่ยกเลิก",
    paymentMethod: "วิธีการชำระเงิน",
    paymentAmount: "จำนวนเงินที่ชำระ",
    paymentDetails: "รายละเอียดการชำระเงิน",
    transactionID: "หมายเลขธุรกรรม",
    transactionDate: "วันที่ทำรายการ",
    cancelDate: "วันที่ยกเลิกการชำระ ",
    searchHint: "ค้นหาด้วยชื่อคอร์ส / เลขคำสั่งซื้อ /ชื่อผู้เรียน",
    export: "นำออก",
    discount:"ส่วนลด",
    addOnDiscount:"ส่วนลดเพิ่มเติม",
    customerName: "ทำรายการโดย",
    fianceDetail: "รายละเอียดการชำระเงิน",
    purchaseValue: "มูลค่าการซื้อ",
    createOrderStep: "สร้างคำสั่งซื้อ",
    paymentSuccess: "ชำระเงินสำเร็จ",
    reportFail:
      "ไม่พบรายงานการเงินที่คุณร้องขอ กรุณาตรวจสอบข้อมูลและลองใหม่อีกครั้ง",
    selectReportLang: "ภาษาในการนำออกรายงาน",
    orderDetail: "รายละเอียดคำสั่งซื้อ",
  },
  schedule: {
    delHolidayConflict:"ไม่สามารถลบวันหยุดได้ เนื่องจากมีคาบเรียนชดเชยที่ถูกเลื่อนจากวันหยุดดังกล่าวมีการลงชื่อเข้าสอนแล้ว",
    exportIns:"ข้อมูลที่นำออกนี้เป็นประวัติการลงชื่อเข้าสอนของอาจารย์ และการเข้าชั้นเรียนของนักเรียน",
    manageByCourse:"จัดการตามคอร์ส",
    manageByClass:"จัดการตามคาบเรียน",
    searchTimeTable: "ค้นหาด้วยชื่อคอร์สหรือชื่อโค้ช...",
    viewStudentList: "ดูรายชื่อนักเรียน",
    editSchedule: "แก้ไขตารางสอน",
    TeachSchedule: "ตารางสอน",
    conflictCourse:"คอร์สที่เปิดสอนในช่วงวันหยุด",
    daily: "รายวัน",
    weekly: "รายสัปดาห์",
    monthly: "รายเดือน",
    manage: "การจัดตารางการสอน",
    seatStatus: "สถานะคอร์ส",
    selectSeatStatus: "เลือกสถานะคอร์ส",
    full: "เต็ม",
    available: "ว่าง",
    coachCheckIn: "การเช็กอินของโค้ช",
    studentCheckIn: "การเช็กอินของนักเรียน",
    alreadyCheckIn: "ลงชื่อเข้าสอนแล้ว",
    notCheckIn: "ยังไม่ลงชื่อเข้าสอน",
    noRecord: "ยังไม่มีบันทึกสถานะการเข้าชั้นเรียน",
    holiday: "วันหยุด",
    manageHoliday: "การจัดการวันหยุด",
    addHoliday: "เพิ่มวันหยุด",
    deleteHoliday: "ลบวันหยุด",
    editHoliday: "แก้ไขวันหยุด",
    confirmDeleteHoliday: "คุณต้องการลบวันหยุดนี้หรือไม่?",
    confirmCreateHoliday: "คุณต้องการเพิ่มวันหยุดนี้ใช่หรือไม่?",
    successAddHoliday: "เพิ่มวันหยุดเรียบร้อยแล้ว!",
    successDeleteHoliday: "ลบวันหยุดเรียบร้อยแล้ว!",
    successEditHoliday: "แก้ไขวันหยุดเรียบร้อยแล้ว!",
    holidayName: "ชื่อวันหยุด",
    holidayDate: "วันที่หยุด",
    holidayDescription: "รายละเอียดวันหยุด",
    searchSchedule: "ค้นหาตารางสอน...",
    checkInDetail: "รายละเอียดการเช็กอิน",
    editHolidayIns:
      "สามารถแก้ไขได้เฉพาะชื่อวันหยุด หากต้องการเปลี่ยนวันที่ กรุณาลบวันหยุดเดิมแล้วเพิ่มใหม่",
  },
  leaveManagement: {
    leaveRequest: "คำขอลา",
    leaveType: "ประเภทการลา",
    leaveDate: "ช่วงวันที่ลา",
    reqDate: "วันที่ส่งคำขอ",
    reason: "เหตุผลในการลา",
    status: "สถานะคำขอ",
    action: "การดำเนินการ",
    approve: "อนุมัติ",
    reject: "ปฏิเสธ",
    pending: "รอการอนุมัติ",
    approved: "อนุมัติแล้ว",
    rejected: "ปฏิเสธคำขอ",
    cancelled: "ยกเลิกคำขอ",
    duplicateReq: "คุณได้ยื่นใบลาในช่วงเวลานี้ไปแล้ว ไม่สามารถยื่นซ้ำได้",
    confirmApprove: "คุณต้องการอนุมัติคำขอนี้ใช่หรือไม่?",
    confirmReject: "คุณต้องการปฏิเสธคำขอนี้ใช่หรือไม่?",
    confirmCancel: "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกใบลานี้?",
    successApprove: "คำขอลาถูกอนุมัติเรียบร้อยแล้ว!",
    successReject: "คำขอลาถูกปฏิเสธเรียบร้อยแล้ว!",
    successCancelLeave:"ยกเลิกใบลาของคุณเรียบร้อยแล้ว!",
    today: "ดูตารางสอนวันนี้",
    searchHint: "ค้นหาด้วยชื่อโค้ช",
    leave: "การลา",
    applicant: "ผู้ลา",
    conflictCourse: "คอร์สที่มีสอนในช่วงเวลาที่ขอลา",
    leaveAllDay: "ลาเต็มวัน",
    leaveAM: "ลาครึ่งวันเช้า",
    leavePM: "ลาครึ่งวันบ่าย",
    leaveTime: "ช่วงเวลาที่ลา",
    addLeave: "เพิ่มบันทึกการลา",
    leaveForm: "แบบฟอร์มการลา",
    personalLeave: "ลากิจ",
    sickLeave: "ลาป่วย",
    vacationLeave: "ลาพักร้อน",
    leaveReason: "เหตุผลในการลา",
    substituteAssign: "มีผู้สอนแทน",
    noSubstitute: "ไม่มีผู้สอนแทน",
    originalClassDate: "วันที่สอนเดิม",
    rejectReason: "คำชี้แจงการไม่อนุมัติ",

    subClassDate: "วันที่สอนชดเชย",
    subClassCoach: "ผู้สอนแทน",
    confirmLeave: "คุณต้องการยืนยันการสร้างใบลานี้ใช่หรือไม่?",
    successCreateLeave: "บันทึกใบลาเรียบร้อยแล้ว !",
    failCreateLeave: "เกิดข้อผิดพลาดในกาสร้างใบลา กรุณาตรวจสอบข้อมูลและลองใหม่อีกครั้ง",
  },
  dashboard: {
    langSelect: "เลือกภาษา",  
    selectedcourse:"รายการคอร์สที่เลือก",
    selectAllIns:"การกดเลือกทั้งหมด จะเลือกเฉพาะคอร์สที่แสดงในหน้านั้น ๆ หากต้องการนำออกรายงานจากทุกคอร์สในระบบ กรุณาเว้นว่างการเลือกคอร์สไว้",
    noIncomeReport:"ไม่พบข้อมูลรายได้จากคอร์สในช่วงเวลานี้",
    fullCourse: "คอร์สเต็ม",
    availableCourse: "คอร์สว่าง",
    unitCoach: "คน",
    enrollCount: "จำนวนคอร์ส",
    active: "ปฏิบัติงาน",
    onLeave: "ลางาน",
    allStudents: "ผู้เรียนทั้งหมด",
    onGoing: "กำลังเรียนอยู่",
    almostDone: "ใกล้เรียนจบ",
    reserved: "จองคอร์สแล้ว",
    courseStatistic: "สถิติคอร์สยอดนิยม",
    topCourse: "10 อันดับคอร์สที่มีผู้เรียนมากที่สุด",
    courseStatusIns: "รายชื่อคอร์สที่มีที่นั่งว่างและที่นั่งเต็มแล้ว",
    courseList:"รายชื่อคอร์ส",
    allYear:"ทั้งปี",
    income:"รายได้",
    IncomeProportion:"สัดส่วนรายได้",
    IncomeProportionIns:"สรุปรายได้จำแนกตามคอร์ส",
    incomeIns:"สรุปรายได้รายวัน/รายเดือน",
    full:"เต็ม",
    available:"ว่าง"
  },
  events: {
    addPicture: "เพิ่มรูป",
    exampleOfPictures: "ตัวอย่างรูปภาพ",
    noImage: "ไม่มีรูปตัวอย่าง",
    advice: "คำแนะนำ",
    suggesImage: "ควรอัปโหลดรูปที่มี ขนาด 1024 x 576 (16:9)",
    save: "บันทึก",
    toManyImage: "ไม่สามารถอัปโหลดรูปภาพมากกว่า10รูป",
    question: "คุณต้องการอัปโหลดอีเว้นท์ใช่หรือไม่",
    yes: "ใช่",
    no: "ไม่",
    success: "อัปโหลดอีเว้นท์เรียบร้อยแล้ว",
    error: "ไม่สามารถอัปโหลดอีเว้นท์เกิน 10 รูป",
    questionDelete: "คุณต้องการลบอีเว้นท์นี้ใช่ไหรือไม่",
    errorDelete: "ไม่สามารถลบอีเว้นท์นี้ได้",
    successDelete: "ลบอีเว้นท์เรียบร้อยแล้ว",

  },
  consent: {
    agree: "ยินยอม",
    dontAgree: "ไม่ยินยอม",
    pdpaTitle:"การยินยอมข้อมูลส่วนบุคคล (PDPA)",
    consent: "ความยินยอม",
  },
  attendance: {
    completed:"เรียนจบแล้ว",
    evaluated:"ประเมินนักเรียนแล้ว",
    allStudent:"นักเรียนทั้งหมด",
    attendanceIns:"จัดการการเข้าเรียนของนักเรียนทั้งหมด",
    total: "ทั้งหมด",
    checked: "เช็คชื่อนักเรียนแล้ว",
    unChecked: "ยังไม่เช็คชื่อนักเรียน",
    index: "ลำดับ",
    courseName: "ชื่อคอร์ส",
    coachName: "ชื่อ-สกุลโค้ช",
    date: "วันที่",
    time: "เวลา",
    status: "สถานะ",
    detail: "รายละเอียด",
    checkInToTeach: "ลงชื่อเข้าสอน",
    unCheckInToTeach: "ยังไม่ได้ลงชื่อเข้าสอน",
    checkInStudent: "เช็คชื่อนักเรียน",
    present: "มาเรียนปกติ",
    late: "มาเรียนสาย",
    absent: "ขาดเรียน",
    leave: "ลา",
    emergencyLeave: "ลาฉุกเฉิน",
    postponed: "เรียนชดเชย",
    unchecked: "ยังไม่เช็คชื่อ",
    SetPostponed: "กำหนดวันเวลาเรียนชดเชย",
    studentName: "ชื่อนักเรียน",
    compensatoryStudyDay: "วันที่เรียนชดเชย",
    compensatoryStudyTime: "เวลาเรียนชดเชย",
    saveAttendance: "บันทึกการเช็คชื่อ",
    cancel: "ยกเลิก",
    savePostponed: "ยืนยันการลา",
    question: "คุณต้องการบันทึกใช่หรือไม่",
    yes: "ใช่",
    no: "ใช่",
    saveSuccess: "บันทึกการเช็คชื่อเรียบร้อยแล้ว",
    errorSave: "บันทึกการเช็คชื่อไม่สำเร็จ",
  },
  reserve: {
    allContactQa: "คุณต้องการเปลี่ยนสถานะ ‘รอติดต่อ’ ทั้งหมดเป็น ‘ติดต่อแล้ว’ ใช่ไหม?",
    searchHint: "ค้นหาด้วยชื่อคอร์สหรือชื่อผู้เรียน...",
    reservedCourse:"คอร์สที่จอง",
    reserveDate: "วันที่จอง",
    studentName:"ชื่อผู้เรียน",
    reserverName:"ชื่อผู้จอง",
    contactedDate:"วันที่อนุมัติการจอง",
    cancelledDate:"วันที่ยกเลิกการจอง",
    phone:"เบอร์ติดต่อ",
    newest:"ใหม่ที่สุด",
    oldest:"เก่าที่สุด",
    reserveDetail:"รายละเอียดการจอง",
    reserverInfo:"ข้อมูลผู้จอง",
    changReserveStatus:"เปลี่ยนสถานะการจอง",
    confirmChangeStatus:"คุณต้องการเปลี่ยนสถานะการจองเป็น \"{status}\" หรือไม่",
    reserveDateRange:"ช่วงวันที่จอง",
    successChangeStatus:"เปลี่ยนสถานะการจองเรียบร้อยแล้ว",
    
  }
};
